import { Box, Flex, Heading } from '@chakra-ui/react';

import { ContentContainer } from '~/components/container';
import { SanityImage } from '~/components/sanity-image';
import { SanityImageType } from '~/features/page-template/models/image';

export function HeroSection({ title, image }: { title: string; image: SanityImageType }) {
  return (
    <Box as='section' bg='blue.800' height='176px' position='relative'>
      <Box height='100%' position='absolute' top={0} width='100%' zIndex={1}>
        <SanityImage image={image} sizes='100vw' style={{ objectFit: 'cover' }} fill priority />
      </Box>

      <ContentContainer height='100%' position='relative' zIndex={2}>
        <Flex
          alignItems='center'
          color='white'
          flexDirection='column'
          gap='16px'
          height='100%'
          justifyContent='center'
          margin='auto'
          position='relative'
          textAlign='center'
          zIndex={1}
        >
          <Heading as='h1' size='marketing-5xl'>
            {title}
          </Heading>
        </Flex>
      </ContentContainer>
    </Box>
  );
}
